'use client';

import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import type { CookieStorageItems } from '@/core/models/cookie-storage';
import CookieStorage from '@/core/services/cookie-storage';

type Key = keyof CookieStorageItems;

export type Context = {
  get: <K extends Key>(k: K) => Promise<CookieStorageItems[K] | null>;
  set: <K extends Key>(k: K, v: CookieStorageItems[K]) => Promise<void>;
  remove: <K extends Key>(k: K) => Promise<void>;
};

export const CookieStorageContext = createContext<Context | null>(null);

export const useCookieStorageContext = () => {
  const context = useContext(CookieStorageContext);
  if (!context) throw Error('CookieStorageContext not found');
  return context;
};

const CookieStorageProvider = ({ children }: PropsWithChildren) => (
  <CookieStorageContext.Provider value={CookieStorage}>
    {children}
  </CookieStorageContext.Provider>
);

export default CookieStorageProvider;
